module.exports = __webpack_public_path__ + "img/plus.034e11e4.png";